import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import  moment from "moment"

export default function TrivvyLinkedRewardsDetailsModal({
  trivvyId,
  open,
  onClose,
  modalData,
  showExpiry
}) {
  const [rewards, setRewards] = useState([]);

  useEffect(() => {


    if(modalData && modalData.length){
      setRewards(modalData)
    }else{
      axios
      .get(url.getTrivvyLinkedRewards(trivvyId))
      .then(({ data }) => {
        setRewards(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    }
   
  }, []);

  return (
    <Modal isOpen={open}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>Linked Rewards</ModalHeader>
      <ModalBody className="p-4">
        {rewards.map((x) => {
          return (
            <div className="my-2">
              <div>
                <b>Name:</b> {x.rewardName}
              </div>
              <div>
                <b>Reward:</b> {x.rewardText}
              </div>
              <div>
                <b>Description:</b>{" "}
                {x.rewardTemplateId && !x.rewardDescription
                  ? x.rewardTemplateId.description
                  : x.rewardDescription}
              </div>

              {
                showExpiry && <div className="mt-2">
                   {moment().isSameOrBefore(moment(x.rewardDate)) ? (
                      ""
                    ) : (
                      <div className="text-danger font-11px">
                        The reward has been closed and you are no longer
                        eligible for the reward.
                      </div>
                    )}
                </div>
              }

              <hr className="mt-2" />
            </div>
          );
        })}
      </ModalBody>
    </Modal>
  );
}
